import axios from 'axios';
import { getRuntimeConfig } from './runtimeConfig';

const DEFAULT_GATEWAY = 'https://api.plataformavirtus.com.br';

// Raiz do api-gateway, sem versão. REACT_APP_API_URL é aceita com ou sem a
// versão no final (".../v1" é o valor atual do ConfigMap de produção) — a
// versão é removida aqui e cada instância abaixo acrescenta a sua. Assim v1
// e v2 convivem sem uma sobrepor a outra (ex.: "/v1/v2/charges").
export const stripVersion = url =>
  String(url)
    .replace(/\/+$/, '')
    .replace(/\/v\d+$/, '');

const gatewayRoot = stripVersion(
  getRuntimeConfig('REACT_APP_API_URL') || DEFAULT_GATEWAY,
);

// api-charge: as chamadas /charges/* carregam a própria versão na URL
// (`/v1/charges/...` ou `/v2/charges/...`), então a base é a raiz, sem
// versão. Em dev local pode apontar para um api-charge rodando na máquina
// (ex.: REACT_APP_API_CHARGE_URL=http://localhost:3333).
const chargeRoot = stripVersion(
  getRuntimeConfig('REACT_APP_API_CHARGE_URL') || gatewayRoot,
);

const create = baseURL => axios.create({ baseURL, timeout: 10000 });

// `api` e `apiV2` já têm a versão no baseURL: uma URL de chamada que também
// começa com versão viraria "/v1/v2/..." (404 silencioso). Falha na hora com
// uma mensagem clara — chamadas versionadas (ex.: /v2/charges) usam apiCharge.
const rejectVersionedUrl = config => {
  if (config.url && /^\/?v\d+\//.test(config.url)) {
    throw new Error(
      `URL com versão (${config.url}) numa instância que já tem versão no baseURL — use apiCharge.`,
    );
  }
  return config;
};

const createVersioned = version => {
  const instance = create(`${gatewayRoot}/${version}`);
  instance.interceptors.request.use(rejectVersionedUrl);
  return instance;
};

// Resto do gateway (layout, cadastro, Vindi etc.) — continua na v1.
const api = createVersioned('v1');

// DTGD-1561: autenticacao com login por CPF + grupo (exige o `host`)
export const apiV2 = createVersioned('v2');

export const apiCharge = create(chargeRoot);

export default api;
